<template>
  <div class="countdown">
    <span v-for="(digit, index) in formattedDays" :key="index" class="digit">
      {{ digit }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    endDate: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      digitStyles: [
        // 初始样式，可以根据需要调整
        { color: "red" },
        { color: "green" },
        { color: "blue" },
        // 继续为其他数字添加样式...
      ],
    };
  },
  computed: {
    remainingDays() {
      const today = Date.now();
      const distance = this.endDate - today;
      return Math.ceil(distance / (1000 * 60 * 60 * 24));
    },
    formattedDays() {
      const days = String(this.remainingDays).padStart(2, "0");
      return days.split("");
    },
  },
};
</script>

<style scoped>
.countdown {
  display: flex;
  align-items: center;
}
.digit {
  width: 45px;
  height: 50px;
  font-size: 40px;
  color: #e62344;
  font-weight: 500;
  text-align: center;
  line-height: 50px;
  background: url("../assets/imgs/count_bg.png") no-repeat;
  background-size: 100% 100%;
}
@media only screen and (max-width: 767px) {
  .digit{
    width: 35px;
    height: 40px;
    line-height: 40px;
    font-size: 0.5rem;
  }
}
</style>